<template>
  <div v-if="payments">
      <v-card class="mt-6">
                    <v-card-title>
                      <v-col>
                        {{title}}
                      </v-col>
                      <v-spacer/>
                      <v-col>
                        <v-text-field
                          v-model="paymentsSearch"
                          append-icon="mdi-magnify"
                          label="Search"
                          single-line
                          hide-details
                        ></v-text-field>
                      </v-col>  
                    </v-card-title>  
                    <v-card-text>                  
                       <v-data-table 
                          :headers="headers" 
                          :items="payments" 
                          dense
                          :items-per-page="-1"
                          fixed-header
                          height="75vh"
                          :search="paymentsSearch"
                          >                          
                          <template v-slot:item.requestedAt="{ item }">
                              <span v-if="item.requestedAt">
                                {{ $dateUtils.formatDateTimeConcise(item.requestedAt) }}
                              </span>
                          </template>               
                          <template v-slot:item.transactionAmount="{ item }">
                              <span>
                                $ {{ item.transactionAmount }}
                              </span>
                          </template>            
                          <template v-slot:item.paidAt="{ item }">
                              <span v-if="item.paidAt">
                                {{ $dateUtils.formatDateTimeConcise(item.paidAt) }}
                              </span>
                          </template>   
                          <template v-slot:item.actionButton="{ item }">
                                <router-link
                                    v-if="!!item.workflowGuid && !!workflowsWithDetailsAndPaymentView.find(x => x == item.workflowTypeDesc) && !!item.registrationId"
                                    class="no-text-decoration"
                                    :to="`/admin/${workflowsLinks.get(item.workflowTypeDesc)}/${item.registrationId}`">                                
                                    <v-btn class="mr-4"> View </v-btn>
                                </router-link>
                          </template>  
                      </v-data-table>
                    </v-card-text>   
                </v-card>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import adminService from "@/services/adminService";
import { MetaNames } from "@/constants";
import { UserInfo } from "@/types/User";

export default Vue.extend({
  name: "AdminPayments",
  data: function() {
      return {
        title: MetaNames.AdminPayments,
        payments: Array<object>(),
        paymentsSearch: '',
        headers: [
            { text: "#ID", align: "left", value: "id", width: "50px" },
            { text: "Registration type", align: "left", value: "workflowTypeDesc", width: "160px" },
            { text: "Fee amount", align: "left", value: "transactionAmount", width: "50px" },
            { text: "Requested at", align: "left", value: "requestedAt", width: "100px" },
            { text: "Requested by admin", align: "left", value: "requestedBy", width: "100px" },
            { text: "Paid by", align: "left", value: "paidBy", width: "200px" },
            { text: "Paid at", align: "left", value: "paidAt", width: "100px" },
            { text: "Payment type", align: "left", value: "paymentTypeDesc", width: "100px" },
            { text: "Admin notes", align: "left", value: "adminNotes", width: "200px" },
            { text: "", align: "left", value: "actionButton", width: "200px" },
        ],
        workflowsWithDetailsAndPaymentView: [
          "KennelRegistration",
          "LitterRegistration",
          //PuppyRelease = 3,
          "LeaseRegistration",
          "AffiliateRegistration",
          "AffiliateRenewal",
          "KennelOwnersChange",
          "QTRegistration",
          // LEPRegistration = 9,
          // MemberRegistration = 10,
          // MemberRenewal = 11,
          // MemberAussieRenewal = 12,
          // PedigreeOrder = 13,
        ],
        workflowsLinks: new Map([
          ["KennelRegistration", "registration/kennels"],
          ["LitterRegistration", "registration/litters"],
          ["LeaseRegistration", "registration/lease"],          
          ["AffiliateRegistration", "registration/affiliate"],
          ["AffiliateRenewal", "renew/affiliate"],
          ["KennelOwnersChange", "changekennelowners"],
          ["QTRegistration", "registration/qtdogs"],
        ])
      };
  },
  methods: {
  },
  watch: {      
    userInfo: function (newVal: object) { 
        adminService
            .getPayments()
            .then((res) => {
                    this.payments = res;
                })
                .catch(this.$handleError);
    },
  },
  created: function () {
    if(this.userInfo){
        adminService
            .getPayments()
            .then((res) => {
                    this.payments = res;
                })
                .catch(this.$handleError);
    }
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
  },
});
</script>
